import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toTitleCase } from "@/lib/titleCase";

export interface SubServiceDB {
  id: string;
  category_id: string;
  name: string;
  description: string;
  duration: string;
  price: number;
  sort_order: number;
}

export interface ServiceCategoryDB {
  id: string;
  title: string;
  tagline: string;
  icon: string;
  sort_order: number;
  subServices: SubServiceDB[];
}

export const useServices = () => {
  const [categories, setCategories] = useState<ServiceCategoryDB[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchServices = async () => {
    setLoading(true);
    const [catRes, subRes] = await Promise.all([
      supabase.from("service_categories").select("*").order("sort_order"),
      supabase.from("sub_services").select("*").order("sort_order"),
    ]);

    const cats = (catRes.data || []) as any[];
    const subs = (subRes.data || []) as SubServiceDB[];

    const merged: ServiceCategoryDB[] = cats.map((c) => ({
      id: c.id,
      title: toTitleCase(c.title),
      tagline: c.tagline,
      icon: c.icon,
      sort_order: c.sort_order,
      subServices: subs
        .filter((s) => s.category_id === c.id)
        .map((s) => ({ ...s, name: toTitleCase(s.name) })),
    }));

    setCategories(merged);
    setLoading(false);
  };

  useEffect(() => {
    fetchServices();
  }, []);

  return { categories, loading, refetch: fetchServices };
};
